module.exports = __webpack_public_path__ + "685e583da488b26da272e7115cc2d24c.svg";